module.exports = __webpack_public_path__ + "static/studio-e7aec379c1bd803d0d86cb4a6e40cfee.png";